import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { ENV } from './environment';
import { RedirectService } from './shared/services/redirect.service';
import { Credentials } from './shared/models/credentials';
import { QUERY_PARAMS, REVIEWS_INSTALLATION_INDICATOR } from './install/shared/navigation/constants';
import { DEFAULT_INTENT } from './signup/platform/state/product_intent';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserService } from '@yotpo-ui/platform-core';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService,
    private redirectService: RedirectService,
    private redCrossService: AnalyticsTrackingProvider,
    private userService: UserService) { }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canActivate(route);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (this.authenticateByUrlParams(route)) {
      return of(true);
    }

    return this.hasUser().pipe(
      map(hasUser => {
        if (!hasUser) {
          this.unauthorizedHandler(route);
          return false;
        }
        this.redCrossIdentify();
        return true;
      }),
      catchError(() => {
        this.unauthorizedHandler(route);
        return of(false);
      })
    );

  }

  private authenticateByUrlParams(route: ActivatedRouteSnapshot): boolean {
    let appKey = route.queryParams[QUERY_PARAMS.APP_KEY] || route.queryParams['app_key'];
    let utoken = route.queryParams[QUERY_PARAMS.UTOKEN];
    if (appKey && utoken) {
      this.authService.setCredentials(new Credentials(appKey, utoken));
      this.redCrossIdentify();
      return true;
    }
    return false;
  }

  private redCrossIdentify() {
    this.redCrossService.identify();
    this.redCrossService.identifiedGroup();
  }

  private unauthorizedHandler(route: ActivatedRouteSnapshot): void {
    this.redirectService.redirectTo(ENV.LoginServiceUrl +
      '#/login?product=' + DEFAULT_INTENT.toLowerCase() +
      '&redirect_to=' + '/' + REVIEWS_INSTALLATION_INDICATOR + '/' + route.routeConfig.path);
  }

  private hasUser(): Observable<boolean> {
    return this.authService.isAuthenticatedAsync()
      .pipe(
        switchMap(isAuthenticated => {
          if (isAuthenticated) {
            return this.userService.getUserData()
              .pipe(map(user => user !== undefined));
          }
          return of(false);
        }));
  }
}
